import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FestaProduct } from '../../interfaces/FestaProduct';

export interface Products {
  searchRows: FestaProduct[];
  }

const initialState: Products = {
  searchRows: [],
};

export interface InputQuantity {
  id: number;
  quantity: number;
};

export const festaSlice = createSlice({
  name: 'festa',
  initialState,
  reducers: {
    set: (state, action: PayloadAction<FestaProduct[]>) => {
      state.searchRows = action.payload;
    },
  }
})

export const { set } = festaSlice.actions;
export default festaSlice.reducer;
